/* eslint-disable id-length */
export class ObjectMap<KEY extends { equals: (other: KEY) => boolean }, VALUE> {
   private map: Map<KEY, VALUE> = new Map();

   constructor(entries?: [KEY, VALUE][]) {
      this.map = new Map(entries);
   }

   public set(key: KEY, value: VALUE): void {
      this.map.set(key, value);
   }

   public get(key: KEY): VALUE | undefined {
      for (const [k, v] of this.map) {
         if (this.equals(k, key)) {
            return v;
         }
      }
      return undefined;
   }

   public has(key: KEY): boolean {
      for (const k of this.map.keys()) {
         if (this.equals(k, key)) {
            return true;
         }
      }
      return false;
   }

   public delete(key: KEY): boolean {
      for (const k of this.map.keys()) {
         if (this.equals(k, key)) {
            return this.map.delete(k);
         }
      }
      return false;
   }

   public get size(): number {
      return this.map.size;
   }

   public forEach(callbackFn: (value: VALUE, key: KEY) => void): void {
      this.map.forEach((value, key) => {
         callbackFn(value, key);
      });
   }

   private equals(a: KEY, b: KEY): boolean {
      return a.equals(b);
   }

   public [Symbol.iterator](): IterableIterator<[KEY, VALUE]> {
      return this.map[Symbol.iterator]();
   }
}
